
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [company, setCompany] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/auth-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`
        },
        body: JSON.stringify({ 
          email, 
          password,
          company: company || null
        })
      });

      const result = await response.json();

      if (result.success && result.user) {
        localStorage.setItem('currentUser', JSON.stringify(result.user));
        navigate('/crm');
      } else {
        alert(result.error || 'Erreur de connexion');
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur de connexion au serveur');
    } finally {
      setLoading(false);
    }
  };

  // Super Admin peut se connecter sans société
  const isSuperAdminLogin = email === 'superadmin@crm.com';

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-xl p-8">
          <div className="text-center mb-8">
            <div className="mx-auto w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4">
              <i className="ri-building-line text-2xl text-white"></i>
            </div>
            <h1 className="text-2xl font-bold text-gray-900">CRM Multi-Sociétés</h1>
            <p className="text-gray-600 mt-2">Connectez-vous à votre espace</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {!isSuperAdminLogin && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Société *
                </label>
                <Input
                  type="text"
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  placeholder="Nom de votre société"
                  required={!isSuperAdminLogin}
                />
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.com"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Mot de passe
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Votre mot de passe"
                required
              />
            </div>

            <Button 
              type="submit" 
              className="w-full" 
              disabled={loading || (!isSuperAdminLogin && !company)}
            >
              {loading ? (
                <>
                  <i className="ri-loader-4-line animate-spin mr-2"></i>
                  Connexion...
                </>
              ) : (
                <>
                  <i className="ri-login-box-line mr-2"></i>
                  Se connecter
                </>
              )}
            </Button>
          </form>

        </div>
      </div>
    </div>
  );
}
